// extracted by mini-css-extract-plugin
export default {"icon":"Header_icon__fh8TE","phone":"Header_phone__xLnYi","inner":"Header_inner__IzISu"};